import { createSelector } from '@ngrx/store';

import { getQueryResults } from '@features/search/infrastructure/state/selectors/search.selectors';
import { getWishlistItems } from '@features/wishlist/infrastructure/state/wishlist.selectors';
import { getProductsId } from '@pages/category/store/category-page.selectors';
import { getProductPageDetail } from '@pages/product';
import { getRelatedProductsPlaces } from '@shared/product/related-products/application/store/related-products.selectors';
import { getCartItems } from '@shared/shopcart/store/shopcart.selectors';

export const getGridPageProductsFiltered = createSelector(getProductsId, (productsId) => productsId);

export const getIndexCalculationValues = createSelector(
    getQueryResults,
    getGridPageProductsFiltered,
    getCartItems,
    getWishlistItems,
    getProductPageDetail,
    getRelatedProductsPlaces,
    (
        queryResults,
        filteredProductsIds,
        cartItems,
        wishListItems,
        productPageProduct,
        relatedProductsPlaces
    ) => {
        return {
            queryResults,
            filteredProductsIds,
            cartItems,
            wishListItems,
            productPageProduct,
            relatedProductsPlaces,
        };
    }
);
